import { MetaForm, MetaObject } from '@softline/dynamic';
import { fieldOkObjectMeta } from '@softapps/wws/core';
import { TimeReportQuery } from '../time-report.query';

export const timeReportQueryMeta: MetaForm<TimeReportQuery> = {
  from: {
    type: 'date',
    label: 'Von',
    required: true,
    format: 'DATE.DEFAULT',
    icon: 'fa-regular fa-calendar-day'
  },
  to: {
    type: 'date',
    label: 'Bis',
    required: true,
    format: 'DATE.DEFAULT',
    icon: 'fa-regular fa-calendar-day'
  },
  objekt: {
    type: 'fieldOk',
    label: 'Objekt',
    fieldOk: 'objekt',
    icon: 'fa-regular fa-frame',
    format: '{{objekt}} - {{bezeichnung}}',
    object: fieldOkObjectMeta,
  }
}
